/**
 * Side By Side block, renders a block with an image on one side, and a text container on the other.
 * Each section takes up 50% of the full block.
 */

import React from 'react';
import { Row, Col, Container } from 'react-bootstrap';
var defaultProps = {
  body: null,
  isTextLeft: true
};
var SideBySideShortBlock = function SideBySideShortBlock(_ref) {
  var backgroundColour = _ref.backgroundColour,
    body = _ref.body,
    media = _ref.media,
    isTextLeft = _ref.isTextLeft,
    heading = _ref.heading;
  var textColOrder = isTextLeft ? 1 : 3;
  var textBlockColourStyling = "bg contentful-" + backgroundColour.toLowerCase().replace(' ', '-');
  return /*#__PURE__*/React.createElement(Container, {
    fluid: true,
    className: "side-by-side-block",
    "data-testid": "side-by-side-block"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: {
      order: 2,
      span: 12
    },
    md: {
      order: 2,
      span: 6
    },
    className: "px-0 image-container",
    "data-testid": "image-container"
  }, media), /*#__PURE__*/React.createElement(Col, {
    xs: {
      order: 1,
      span: 12
    },
    md: {
      order: textColOrder,
      span: 6
    },
    className: "pl-0 justify-content-center pt-1 pt-md-5 " + textBlockColourStyling + " text-container",
    "data-testid": "text-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pl-5 mb-5 mt-4"
  }, heading), body && /*#__PURE__*/React.createElement("div", {
    className: "pl-5 mb-5"
  }, body))));
};
SideBySideShortBlock.defaultProps = defaultProps;
export { SideBySideShortBlock };